function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import React, { useState, useRef, useEffect } from 'react';
import Select from 'react-select';
import { BASE_SINGLE_SELECT_PROPS } from '../../../utils/constants';
import throttle from 'lodash/throttle';
const reactSelectSingleUiSettings = BASE_SINGLE_SELECT_PROPS;
const SelectReplace = _ref => {
  let {
    name,
    id,
    value,
    label,
    options,
    placeholder,
    fieldError,
    changeEvent = () => {},
    blurEvent = () => {},
    mouseDownEvent = () => {},
    focusEvent = () => {},
    keyDownEvent = () => {},
    touchStartEvent = () => {},
    componentColor,
    isSearchable = false
  } = _ref;
  const clickedDropRef = useRef(false);
  const [dropOpened, setDropOpened] = useState(false);
  const [highLightDrop, setHighLightDrop] = useState(false);
  const handleScrollWindow = throttle(() => {
    setDropOpened(false);
  }, 500);
  const handleChange = event => {
    changeEvent(event);
    setDropOpened(false);
  };
  const handleBlur = event => {
    blurEvent();
    clickedDropRef.current = false;
    setHighLightDrop(false);
    setDropOpened(false);
  };
  const handleDropFocus = () => {
    focusEvent();
    if (!clickedDropRef.current) {
      setHighLightDrop(true);
    }
  };
  const handleDropMousedown = () => {
    mouseDownEvent();
    clickedDropRef.current = true;
    setDropOpened(!dropOpened);
  };
  const handleDropKeyDown = e => {
    keyDownEvent();
    if (e.which === 13 || e.which === 32) {
      setDropOpened(!dropOpened);
      if (!dropOpened) {
        e.preventDefault();
      }
    }
    if (e.which === 27) {
      setDropOpened(false);
    }
  };
  const handleDropTouchstart = e => {
    touchStartEvent();
    const dropListTouched = !!e.target.closest('.select-dropdown__menu');
    if (!dropListTouched) {
      setDropOpened(!dropOpened);
    }
  };
  useEffect(() => {
    if (dropOpened) {
      window.addEventListener('scroll', handleScrollWindow);
    }
    return () => {
      window.removeEventListener('scroll', handleScrollWindow);
    };
  }, [dropOpened, handleScrollWindow]);
  return /*#__PURE__*/React.createElement("div", {
    onMouseDown: handleDropMousedown,
    onTouchStart: handleDropTouchstart,
    style: {
      '--component-color': componentColor
    }
  }, /*#__PURE__*/React.createElement(Select, _extends({}, reactSelectSingleUiSettings, {
    name: name,
    id: id,
    options: options,
    value: value,
    className: `
        react-custom-select
        ${highLightDrop ? 'react-custom-select--outlined' : ''}
        ${fieldError ? 'react-custom-select--error' : ''}
      `,
    placeholder: placeholder,
    onChange: handleChange,
    onFocus: handleDropFocus,
    onMouseDown: handleDropMousedown,
    onKeyDown: handleDropKeyDown,
    onBlur: handleBlur,
    "aria-label": label,
    "aria-labelledby": label,
    menuIsOpen: dropOpened,
    isSearchable: isSearchable
  })));
};
export default SelectReplace;